import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText, MenuList } from '@mui/material';

// assets
import { CodepenOutlined, ProfileOutlined, LogoutOutlined, UserOutlined, WalletOutlined, FileTextOutlined } from '@ant-design/icons';
import useMain from 'hooks/useMain';
import { useSelector } from 'react-redux';
import { handleLogout } from 'store/reducers/authentication';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const MainMenuList = ({ handleClose }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { t, useNavigate, useLocation, dispatch } = useMain();
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const location = useLocation();
  const menuList = useSelector((s) => s.menu.menuList);
  const navigate = useNavigate();

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      {menuList.map(({ Icon, text, id }, index) => (
        <ListItemButton
          key={`menu_${text}`}
          selected={location.pathname.includes(id)}
          onClick={(e) => {
            handleClose(e);
            handleListItemClick(e, index);
            if (id === 'logout') {
              dispatch(handleLogout());
              navigate('login');
              return;
            }

            navigate(id);
          }}
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={t(text)} />
        </ListItemButton>
      ))}
    </List>
  );
};

MainMenuList.propTypes = {
  handleLogout: PropTypes.func
};

export default MainMenuList;
